import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Companies from "../pages/Companies";
import CompaniesNew from "../pages/Companies/new";
import CompanyDetail from "../pages/Companies/Detail";
import CompanyEdit from "../pages/Companies/Edit";
import Plans from "../pages/Plans";
import Subscriptions from "../pages/Subscriptions";
import Invoices from "../pages/Invoices";
import Payments from "../pages/Payments";
import Audit from "../pages/Audit";
import Settings from "../pages/Settings";
import AsaasIntegration from "../pages/Integrations/Asaas";
import Fiscal from "../pages/Fiscal";
import BillingEvents from "../pages/BillingEvents";
import FeatureFlags from "../pages/FeatureFlags";
import Forbidden from "../pages/Forbidden";
import NotFound from "../pages/NotFound";
import Profile from "../pages/Profile";
import ChangePassword from "../pages/ChangePassword";
import Announcements from "../pages/Announcements";
import Connections from "../pages/Connections";
import GlobalSettings from "../pages/GlobalSettings";
import ApiPresets from "../pages/ApiPresets";
import AdminUsers from "../pages/AdminUsers";
import Finance from "../pages/Finance";
import Monitoring from "../pages/Monitoring";
import AdminLayout from "../layout/AdminLayout";

const AdminRoutes = () => (
  <Switch>
    <Route path="/login" component={Login} />
    <Route path="/forbidden" component={Forbidden} />
    <Route>
      <AdminLayout>
        <Switch>
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/companies/new" component={CompaniesNew} />
          <PrivateRoute path="/companies/:id/edit" component={CompanyEdit} />
          <PrivateRoute path="/companies/:id" component={CompanyDetail} />
          <PrivateRoute path="/companies" component={Companies} />
          <PrivateRoute path="/plans" component={Plans} />
          <PrivateRoute path="/subscriptions" component={Subscriptions} />
          <PrivateRoute path="/invoices" component={Invoices} />
          <PrivateRoute path="/payments" component={Payments} />
          <PrivateRoute path="/users" component={AdminUsers} />
          <Route exact path="/admin-users" render={() => <Redirect to="/users" />} />
          <PrivateRoute path="/audit" component={Audit} />
          <PrivateRoute path="/settings" component={Settings} />
          <PrivateRoute path="/integrations/asaas" component={AsaasIntegration} />
          <PrivateRoute path="/fiscal" component={Fiscal} />
          <PrivateRoute path="/billing-events" component={BillingEvents} />
          <PrivateRoute path="/feature-flags" component={FeatureFlags} />
          <PrivateRoute path="/announcements" component={Announcements} />
          <PrivateRoute path="/connections" component={Connections} />
          <PrivateRoute path="/global-settings" component={GlobalSettings} />
          <PrivateRoute path="/api-presets" component={ApiPresets} />
          <PrivateRoute path="/finance" component={Finance} />
          <PrivateRoute path="/monitoring" component={Monitoring} />
          <PrivateRoute path="/profile" component={Profile} />
          <PrivateRoute path="/change-password" component={ChangePassword} />
          <Route path="/404" component={NotFound} />
          <Redirect exact from="/" to="/dashboard" />
          <Route component={NotFound} />
        </Switch>
      </AdminLayout>
    </Route>
  </Switch>
);

export default AdminRoutes;